module.exports = __webpack_public_path__ + "img/92.fff44029.jpg";